<template>
    <v-row class="release-certificate-datum-container text-left pl-5" v-if="alignItGood" dense>
        <v-col cols="4" :class=" `release-certficate-label`+ ` `+fontWeight">
            {{label}}
        </v-col>
        <v-col cols="6" class="release-certficate-value" v-if="arrayValue">
            <ul>
                <li v-for="(v, index) in arrayValue" :key="index">
                    {{v}}
                </li>
            </ul>
        </v-col>
        <v-col cols="6" class="release-certficate-value" :style="{backgroundColor:backgroundColor}" v-else>
            {{value}}
        </v-col>
    </v-row>
    <div class="release-certificate-datum-container" v-else>
        {{label}}: <span class="release-certficate-value">{{value}}</span>
    </div>
</template>

<script>

export default {
    components: {
        
    },
    props: {
        label: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: null
        },
        arrayValue: {
            type: Array,
            default: null
        },
        alignItGood: {
            type: Boolean,
            default: true
        },
        fontWeight: {
            type: String,
            default:null
        },
        backgroundColor:{
            type:String,
            default:null
        }
    },
    data() {
        return {
            
        }
    },
    computed: {
  
    },
    methods: {
        
    },
    watch: {
        
    },
    async created() {
        
    }
}

</script>

<style lang="scss" scoped>
    #app {
        .release-certificate-datum-container {

            font-size: 12px;
            .release-certficate-label {
                text-align: left;
                text-transform: uppercase;
            }

            .release-certficate-value {
                text-align: left;
                font-weight: bold;
                padding: 0;
                margin-bottom: 10px;
                
                ul {
                    
                    display: inline-block;
                    
                    li{
                    background-color: yellow;
                    margin-bottom: 10px;
                }

                }
               
                
            }

            /* do not show the dots for list items */
            ul {
                list-style-type: none;
                padding-left: 0px;
            }
        }
        
    }
</style>